import { render, staticRenderFns } from "./new_mass_chat_message.vue?vue&type=template&id=5b704967&scoped=true&"
import script from "./new_mass_chat_message.vue?vue&type=script&lang=js&"
export * from "./new_mass_chat_message.vue?vue&type=script&lang=js&"
import style0 from "./new_mass_chat_message.vue?vue&type=style&index=0&id=5b704967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b704967",
  null
  
)

export default component.exports